export const PhoneNumberMask = () => {
  const ukrainianPhoneMask = (value) => {
    const formatPartial = (digits) => {
      if (!digits) return '';

      let result = '';

      // +38
      if (digits.length > 0) {
        result = '+' + digits.slice(0, 2);
      }
      // +38 (
      if (digits.length > 2) {
        result += ' (';
        if (digits.length <= 5) {
          result += digits.slice(2, 5);
        } else {
          result += digits.slice(2, 5) + ') ';
        }
      }
      // XXX
      if (digits.length > 5) {
        result += digits.slice(5, 8);
      }
      // XX
      if (digits.length > 8) {
        result += ' ' + digits.slice(8, 10);
      }
      // XX
      if (digits.length > 10) {
        result += ' ' + digits.slice(10, 12);
      }

      return result;
    };

    if (!value) return '';

    let digits = value.replace(/\D/g, '');

    if (digits.length > 0 && !digits.startsWith('38')) {
      digits = '38' + digits;
    }

    digits = digits.slice(0, 12);

    return formatPartial(digits);
  };

  return {
    ukrainianPhoneMask,
  };
};